import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({ height: window.innerHeight })
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({ width: window.innerWidth })
        }
    }


    componentDidMount() {
        this.setState({ height: window.innerHeight, width: window.innerWidth })
        window.addEventListener('resize', this.updateDimensions)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;            
            }            
        `

        const Overlay = styled.div`
            width: 100%;
            display: block;
            align-items: center;
            background-color: rgba(0,0,0);
            height: 500px;            
            @media (min-width:768px) and (max-width:1500px) {
                height: 500px;
            }
            @media (max-width:767px) {
                height: 250px;                
            }
        `

        const Heading2 = styled.h2`
            font-size: 50px;
            font-family: Poppins;
            line-height: 40px;
            color: #fff;
            font-weight: bold;
            text-transform: uppercase;
            @media (min-width:768px) {
                margin-left: 4px;
            }            
            @media (min-width:768px) and (max-width:1500px) {
                font-size: 50px;
                line-height: 70px;
            }
            @media (max-width:767px) {
                font-size: 40px;
                line-height: 40px;
                margin-left: 2px;
            }
        `

        const Heading3 = styled.h3`
            font-size: 30px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #c1eb18 , #65ff00);
            background: -o-linear-gradient(right, #c1eb18, #65ff00);
            background: -moz-linear-gradient(right, #c1eb18, #65ff00);
            background: linear-gradient(to right, #c1eb18, #65ff00); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 35px;
            }
        `

        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #C1EB18;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const BottomContent = styled.div`
            position: absolute;
            width: 100%;
            bottom: -34%;
            z-index: 2;
            margin-bottom: 100px;
            @media (min-width:1025px) and (max-width: 1500px) {    
                bottom: -50%;
            }            
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `

        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 14px;
            font-weight: 300;
            color: #c5c5c5;
        `

        return (
            <Section id="validacion">
                <Overlay>
                    <Container>
                        <Content>
                            <Heading2>
                                Tipos de Certificados Digitales
                            </Heading2>
                            <Heading3>
                                Asegurando la confianza Online
                            </Heading3>
                            <Separator />
                        </Content>
                    </Container>
                </Overlay>
                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="SSL por Validación de Dominio (DV)" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Validación de Dominio (DV)
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Los Certificados DV son los más comunes y básicos. Verifican únicamente la propiedad del dominio, lo que significa que
                                            el titular del certificado posee el control del dominio asociado al sitio web. Son fáciles de adquirir y ofrecen una
                                            confianza básica para los visitantes del sitio web. Este tipo de certificado SSL, se emiten en minutos.<br></br><br></br><br></br><br></br>
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Certificados SSL por Validación de Organización (OV)" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Validación de Entidad (OV)
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Los Certificados OV van un paso más allá. Además de confirmar la propiedad del dominio, estos certificados autentican la
                                            existencia y la identidad de la Organización detrás del sitio web. Son ideales para empresas que desean mostrar a sus clientes
                                            que han pasado por un proceso de validación adicional y que existen realmente.<br></br><br></br><br></br><br></br>
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={4}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Certificados SSL en Colombia por Validación Extendida (EV)" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Validación Extendida (EV)
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Los Certificados EV ofrecen el más alto nivel de validación y confianza. Además de verificar la propiedad del dominio y la
                                            identidad de la organización, estos certificados también muestran la información de la empresa u organización que se esta
                                            visitando, lo que indica a los usuarios que están navegando en un sitio altamente seguro y confiable. Son ideales para
                                            empresas que desean transmitir confianza y profesionalismo a todos sus clientes.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>
            </Section>
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/domains.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/factory2.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/protected.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }          
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            return <Hero data={data} image1={image1} image2={image2} image3={image3}{...props} />;
        }}
    />
);

export default Iconos;
